<ng-template #fieldValueTemplate let-cardField>
    <div
        class="field-value"
        [ngClass]="{
            'field-value-vertical': verticalOrder(),
            'field-value-horizontal': !verticalOrder(),
        }"
        appLongTextTooltip
        [innerHTML]="shouldRenderAsHtml(cardField) ? (cardField.value | toNumberedList | newLineCharToHtmlLineBreak) : cardField.value">
        {{ !shouldRenderAsHtml(cardField) ? cardField.value : "" }}
    </div>
</ng-template>

<div class="fields">
    <div
        *ngFor="let cardField of cardFields(); let i = index"
        appHoverHighlight
        class="field-container"
        [ngClass]="{
            'field-container-vertical': verticalOrder(),
            'field-container-horizontal': !verticalOrder(),
        }">
        <div class="field-key" [ngClass]="{ 'field-key-horizontal': !verticalOrder() }" [title]="cardField.descriptionLabelPath | labelsProvider">
            <div>{{ cardField.key }}</div>

            @if (
                (resourceType() === resourceTypeEnum.gpt && copyableFields.includes(cardField.key)) ||
                (resourceCategory() === resourceCategoryEnum.bot && cardField.key === instructionsFieldName)
            ) {
                <app-copy-button [value]="getClipboardText(cardField.value ?? '', cardField.additionalValues)" class="copy-button" />
            }
        </div>

        <div class="field-value-container" [ngClass]="{ 'field-value-container-horizontal': !verticalOrder() }" #fieldEl>
            @if (cardField.customTemplate) {
                <ng-container *ngTemplateOutlet="cardField.customTemplate" />
            }

            <app-risk-mapping-score-column [dictSeverity]="cardField.dictSeverity" *ngIf="isDictSeverityNotEmpty(cardField.dictSeverity)">
            </app-risk-mapping-score-column>

            @if (cardField.value && cardField.isCopyable) {
                <app-copy-button [value]="getClipboardText(cardField.value, cardField.additionalValues)" />
            }

            <img class="icon" [ngClass]="{ 'icon-primary-color': cardField.valueLink }" *ngIf="cardField.iconPath" [src]="cardField.iconPath" />

            <div
                *ngIf="!cardField.valueLink && !cardField.method && cardField.copyableText"
                class="field-value"
                [ngClass]="{
                    'field-value-vertical': verticalOrder(),
                    'field-value-horizontal': !verticalOrder(),
                }"
                appLongTextTooltip>
                {{ cardField.copyableText }}
            </div>

            @if (cardField.valueLink) {
                <app-anchor-link [navigation]="cardField.valueLink" class="field-link-value">
                    <span class="field-link-value__text" appLongTextTooltip>{{ cardField.value }}</span>
                </app-anchor-link>
            }

            @if (cardField.method) {
                <app-anchor-link navigation="" (clicked)="cardField.method()" class="field-link-value">
                    <span class="field-link-value__text" appLongTextTooltip>{{ cardField.value }}</span>
                </app-anchor-link>
            }

            @if (cardField.internalNavigation) {
                <app-anchor-link
                    [navigation]="{
                        commands: cardField.internalNavigation.page ? [cardField.internalNavigation.page] : [],
                        queryParams: cardField.internalNavigation.query,
                        queryParamsHandling: 'merge',
                    }"
                    class="field-link-value">
                    <span class="field-link-value__text" appLongTextTooltip>{{ cardField.value }}</span>
                </app-anchor-link>
            }

            @if (cardField.tooltipLabelPath && cardField.tooltipIconPath) {
                <div class="field-value-tooltip-image">
                    <span class="text-tooltip">
                        {{ cardField.value }}
                    </span>
                    <img
                        class="icon-field"
                        [src]="cardField.tooltipIconPath"
                        height="16px"
                        matTooltip="{{ cardField.tooltipLabelPath | labelsProvider }}" />
                </div>
            }

            @if (
                !cardField.valueLink &&
                !cardField.method &&
                !cardField.isRawValue &&
                !cardField.copyableText &&
                !cardField.internalNavigation &&
                !isDictSeverityNotEmpty(cardField.dictSeverity) &&
                !cardField.tooltipIconPath &&
                !cardField.tooltipLabelPath
            ) {
                @if (resourceType() === resourceTypeEnum.gpt && cardField.key === conversationStartersFieldName) {
                    @if (overflowVerticalConversationStartersBlock()) {
                        <app-toggle-content
                            [cardField]="cardField"
                            [truncatedMaxHeightForConversationStartersBlock]="truncatedMaxHeightForConversationStartersBlock" />
                    } @else {
                        <ng-container *ngTemplateOutlet="fieldValueTemplate; context: { $implicit: cardField }"> </ng-container>
                    }
                } @else if (
                    overflowHorizontalItems()[i] &&
                    ((resourceCategory() === resourceCategoryEnum.bot && cardField.key === instructionsFieldName) ||
                        cardField.key === resourceDescriptionFieldName)
                ) {
                    <app-toggle-content [cardField]="cardField" />
                } @else {
                    <ng-container *ngTemplateOutlet="fieldValueTemplate; context: { $implicit: cardField }"> </ng-container>
                }
            }

            <app-additional-values
                *ngIf="cardField.additionalValues && cardField.additionalValues.length > 0"
                [additionalValues]="cardField.additionalValues">
            </app-additional-values>

            <app-get-sensitive-data-input-action
                *ngIf="cardField.isRawValue"
                [sensitiveDataMethod]="cardField.sensitiveDataMethod"
                [confirmtionData]="cardField.confirmedData"
                [showPopupBtn]="cardField.showPopupBtn ? true : false"
                [content]="cardField.value ?? ''">
            </app-get-sensitive-data-input-action>
        </div>
    </div>
</div>
